<!-- START CONTENT -->
<section id="main-content" class="sidebar_shift">
  <section class="wrapper main-wrapper row">
    <h3 *ngIf="isNewUser">Create New User</h3>
    <h3 *ngIf="!isNewUser">Update User</h3>
    <hr />
    <form [formGroup]="newUserForm" (ngSubmit)="createUser(newUserForm.value)" autocomplete="off">
      <div class="container">
        <div class="row text-danger" *ngIf="!isUserFormValid()">
          <label> {{errorMessage}}</label>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label class="form-label" for="exampleInputEmail1">Email address:</label>
            <input *ngIf="isNewUser" type="email" class="form-control" id="email" name="Email" placeholder="Enter email" formControlName="Email">
            <h2 *ngIf="!isNewUser">{{User.Email}}</h2>
            <em *ngIf="newUserForm.controls.Email.invalid&&newUserForm.controls.Email.touched" class="text-danger">Required</em>
            <em *ngIf="emailInUse" class="text-danger">This email already used!</em>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="form-label" for="firstname">First name:</label>
            <input type="text" class="form-control" id="firstName" placeholder="Enter first name" formControlName="FirstName">
            <em *ngIf="newUserForm.controls.FirstName.invalid&&newUserForm.controls.FirstName.touched" class="text-danger">Required</em>
          </div>
          <div class="form-group col-md-6">
            <label class="form-label" for="lastName">Last name:</label>
            <input type="text" class="form-control" id="lastName" placeholder="Enter last name" formControlName="LastName">
            <em *ngIf="newUserForm.controls.LastName.invalid&&newUserForm.controls.LastName.touched" class="text-danger">Required</em>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="form-label" for="tel">Tel:</label>
            <input type="text" class="form-control" id="tel" placeholder="Enter telphone  number" formControlName="Tel">
            <em *ngIf="newUserForm.controls.Tel.invalid&&newUserForm.controls.Tel.touched" class="text-danger">Required</em>
          </div>
          <div class="form-group col-md-6">
            <label class="form-label" for="Site">Site</label>
            <select formControlName="Site" class="form-control input-md m-bot15" (change)="onSiteChange($event)">
              <option *ngFor="let site of Sites" [value]="site.SiteId">
                {{site.SiteName}}
              </option>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <ul class="list-unstyled">
              <li>
                <label class="form-label icheck-label" for="canViewResults">Results Viewer?</label>
                <input type="checkbox" id="canViewResults" formControlName="CanViewResults" class="icheckbox_square-blue">
                <em *ngIf="newUserForm.controls.CanViewResults.invalid&&newUserForm.controls.CanViewResults.touched" class="text-danger">Required</em>
              </li>
              <li>
                <label class="icheck-label form-label" for="canOrderKits">Can order kits?</label>
                <input type="checkbox" id="canOrderKits" formControlName="CanOrderKits" class="icheckbox_square-blue">
                <em *ngIf="newUserForm.controls.CanOrderKits.invalid&&newUserForm.controls.CanOrderKits.touched" class="text-danger">Required</em>
              </li>
              <li>
                <label class="icheck-label form-label" for="canRequest">Can Request?</label>
                <input type="checkbox" id="canRequest" formControlName="CanRequest" class="icheckbox_square-blue" (click)="onCanRequestChange()">
                <em *ngIf="newUserForm.controls.CanRequest.invalid&&newUserForm.controls.CanRequest.touched" class="text-danger">Required</em>
              </li>
              <li *ngIf="isCanSeeAllSiteResultsEnabled()">
                <label class="icheck-label form-label" for="canSeeAllSiteResults">Can View All Site Results?</label>
                <input type="checkbox" id="canSeeAllSiteResults" formControlName="CanSeeAllSiteResults" class="icheckbox_square-blue"  (click)="onCanSeeAllSiteResultsChange()">
                <em *ngIf="newUserForm.controls.CanSeeAllSiteResults.invalid&&newUserForm.controls.CanSeeAllSiteResults.touched" class="text-danger">Required</em>
              </li>
            </ul>
          </div>
          <div class="form-group col-md-6" *ngIf="User.Site == 2">
            <label class="form-label" for="clinician">Clinician:</label>
            <input type="text" class="form-control" id="clin" placeholder="Enter clin code" formControlName="Clinician">
            <em *ngIf="newUserForm.controls.Clinician.invalid&&newUserForm.controls.Clinician.touched" class="text-danger">Max 10</em>
          </div>
        </div>
        <div class="form-row">
          <hr />
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <h2> Sources</h2>
            </div>
            <div class="form-group col-md-6 no-left-padding">
              <mat-form-field class="example-full-width">
                <input type="text" [formControl]="myControl" matInput [matAutocomplete]="auto" class="form-control" />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let source of Sources" [value]="source.SourceCode" (onSelectionChange)="selectSource($event, source)">
                    {{ source.SourceCode }} - ({{source.Site}})
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="form-group col-md-6">
              <button (click)="addSource()" [disabled]="!canAddSource(selectedSource)" class="btn btn-sm" [ngClass]="{'btn-primary':canAddSource(selectedSource),'btn-warning':!canAddSource(selectedSource)}">
                <i class="fa fa-plus-circle"></i>
              </button>

            </div>
          </div>

        <div class="form-row">


            <table class="table">
              <tr *ngFor="let source of User.Sources">
                <td>
                  <div class="row source-header">
                    <div class="col-md-10 row-source">{{source.SourceCode}}</div>
                    <div class="col-md-2 row-source">
                      <!--<input type="button" value="Remove" (click)="removeSource(source)" class="btn-default  btn-danger" />-->

                      <button (click)="removeSource(source)" class="btn btn-sm btn-info">
                        <i class="fa fa-minus-circle"></i>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

        </div>
        <hr />
        <div class="form-row">
          <div class="form-group">
            <button type="submit" class="btn btn-success btn-block" [disabled]="!isUserFormValid()">Submit</button>

          </div>
        </div>
        <div class="form-row">
          <div class="form-group">

            <button type="button" class="btn btn-success btn-block" (click)="cancel()">Cancel</button>
          </div>
        </div>
      </div>
    </form>
  </section>
</section>
